export default function composeService() {
    return function () {
        let args = arguments
        let start = args.length - 1
        return function () {
            let i = start
            let result = args[i].apply(this, arguments)
            while (i--) result = args[i].call(this, result)
            return result
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/services/composeService.js